export default {
    "map": {
        "baseMapType": "roadmap",
        "baseZoom": 18,
        "baseLat": 50.0755381,
        "baseLng": 14.4378005,
        "mapTypeControl": false,
    },
    "polyline": {
        "strokeColor": "#FF0000",
        "strokeOpacity": 1.0,
        "strokeWeight": 3,
        "geodesic": true,
    },
    "api": {
        "protocol": "https",
        "tilesUtl": "cdn.scitani2021.algorim.dev/mapdata/tiles",
        "snapToRoadsUrl": "roads.googleapis.com/v1/snapToRoads",
    },
};